// extracted by mini-css-extract-plugin
export default {"wrapper":"BannerCard_wrapper__6gmnB","isFullWidth":"BannerCard_isFullWidth__dhSch"};